import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  FileInput,
  FileField,
} from 'react-admin';

export const AppReleaseCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="version" label="Version" isRequired />

      <FileInput source="apk_file" label="APK file" accept=".apk" isRequired>
        <FileField source="src" title="title" />
      </FileInput>

      <BooleanInput source="is_active" label="Is active" defaultValue={true} />
    </SimpleForm>
  </Create>
);